<div id="deleteLeadPopUp">
  <div mat-dialog-title class="ds">
    <span>{{componentTitle}}</span>
    <button mat-icon-button class="close-dialog-button" mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content class="content ds">
    <ds-multiline id="reasonTextfield" class="fill-width" [label]="appStrings.accounts_deleteLead_reasonTitle" label_orientation="vertical-label" 
      [control]="selectForm.controls.reason">
    </ds-multiline>
  </div>
  <div mat-dialog-actions id="reasonButtons" align="end" class="ds">
    <div class="dialog-btn-wrapper">
      <ds-button 
          id="closeButtonDeleteLeadMobile" 
          variant="label-only" 
          size="medium" 
          type="secondary" 
          (onClick)="close()" 
          [label]="appStrings.button_close">
        </ds-button>
        <ds-button 
          id="deleteButtonDeleteLeadMobile" 
          variant="label-only" 
          size="medium" 
          type="primary" 
          (onClick)="deleteLead()" 
          [label]="appStrings.button_delete">
        </ds-button>
    </div>
  </div>
</div>